import { useState, createContext, useEffect, useCallback } from 'react';
import { AppGeneralContextType, ContextProviderProps, LoginType, MatchStatus } from '../../components/types/Context';
import { StartUp, UserInfo, initalStartUp, initialuserInfo, Corporate, User, Filter, initialStateModal, Modal, ModalType, MatchDate, initialCorporate, OptionTypes, Match, StartupAcceptedMatchType, ChatMessage, ModalChildrenPar, initialStateDatesResponse, DatesResponse, AppSettings } from '../../components/types/types';
import { useScrollBlock } from '../../hook/useScrollBlock';
import { CompaniesListReq, MatchListReq, MessagesListReq, Pager, StartupsListFiltersReq, StartupsListReq } from '../../components/types/Api';
import { initialPager, initialReqCorporate, initialReqMatchList, initialReqMessagesList, initialReqStartup } from '../../components/types/InitialData';
import { callGetStartupByIdGuest, getDepartmentsList, getFilterList, getLevelList, getMatchFeaturedServices, getServicesBanner, getStartUpByID, getUser, postCompaniesList, postMatchList, postMessagesList, postStartupsList } from '../../api/Api';
import axios, { AxiosResponse } from 'axios';
import { DTOStartupById } from 'components/types';
import { dayMonthYearString } from 'shared/utils/formatFunction';
import useMediaQuery from 'hook/useMediaQuery';
import { MediaMobile } from 'api/const/MediaQuery';
import { PAGE_SIZE } from 'shared/const';
import { MultiValue } from 'react-select';
import { StatusCode } from 'api/const';
import { Service } from 'components/pagine';
import * as authHelper from 'shared/auth/authHelpers'

export const AppGeneralContext = createContext<AppGeneralContextType>(
    {
        baseUri: undefined,
        loginType: undefined,
        setLoginType: (type: LoginType | undefined) => { },
        //forgot password nav
        isForgotPassword: false,
        setIsForgotPassword: (par: boolean) => { },
        isChooseNewPassword: false,
        setIsChooseNewPassword: (par: boolean) => { },
        forgotPWNewEmail: "",
        setForgotPWNewEmail: (par: string) => { },

       //Reset Email
        resetEmailisOpen:false,
        setresetEmailisOPen:(par: boolean) => { },
        
       // GenerateVerificationCode
        generateVerifCodeisOpen :false,
        setGenerateCodeisOpen:(par: boolean) => {},

        //login
        user: undefined,
        setUser: (user: User | undefined) => { },

        //register
        userInfo: initialuserInfo,
        setUserInfo: (user: UserInfo) => { },
        menuIsOpen: false,
        setMenuIsOpen: (isOpen: boolean) => { },
        startUp: initalStartUp,
        setStartUp: (user: StartUp) => { },
        numberMatchRequest: 0,
        setNumberMatchRequest: (par: number) => { },
        chatIsOpen: false,
        setChatIsOpen: (chatIsOpen: boolean) => { },
        corporate: initialCorporate,
        setCorporate: (corporate: Corporate) => { },

        //Corporates List
        isLoadingCorporates: false, //todo settare a true con api
        setIsLoadingCorporates: (isLoading: boolean) => { },
        corporatesList: [],
        reqCorporate: initialReqCorporate,
        setCorporatesList: (corporates: Corporate[]) => { },
        pagerCorporatesList: initialPager,
        setPagerCorporatesList: (pager: Pager) => { },
        setReqCorporate: (req: CompaniesListReq) => { },
        getCorporatesList: () => { },

        //Startup List
        startupsList: [],
        reqStartup: initialReqStartup,
        setStartupsList: (startups: StartUp[]) => { },
        pagerStartupsList: initialPager,
        setPagerStartupsList: (pager: Pager) => { },
        setReqStartup: () => { },
        isLoadingStartups: false, //todo settare a true con api
        setIsLoadingStartups: (isLoading: boolean) => { },
        getStartupsList: (logged: boolean, req?:StartupsListFiltersReq) => { },


        getUserData: (whoLogsIn: number) => new Promise(() => { }),


        modal: initialStateModal,
        setModal: (modal: Modal) => { },

        modalChildren: {},
        setModalChildren: (modal: ModalChildrenPar) => { },

        setLoadingModal: () => { },
        setErrorModal: (_?: string) => { },
        setClosedModal: () => { },
        //selectDates
        modalDatesIsOpen: false,
        setModalDatesIsOpen: (par: boolean) => { },
        dateResponse: initialStateDatesResponse,
        setDateResponse: (dateResponse: DatesResponse) => { },
        matchCallDates: undefined,
        setMatchCallDates: (par: MatchDate[]) => { },
        resetMatchCallDates: () => { },
        startUpIdforMatch: "",
        setstartUpIdforMatch: (startUpIdforMatch: string) => { },

        loadingDepartmentOptions: true,
        setLoadingDepartmentOptions: (par: boolean) => { },
        departmentOptions: [],
        setDepartmentOptions: (par: OptionTypes[]) => { },
        getDepartmentsOptionsList: () => { },

        loadingLevelsOptions: true,
        setLoadingLevelsOptions: (par: boolean) => { },
        levelsOptions: [],
        setLevelOptions: (par: OptionTypes[]) => { },
        getLevelOptionsList: () => { },

        //filter
        filter: {},
        setFilter: (filter: Filter) => { },
        loadingFilterOptions: true,
        setLoadingFilterOptions: (par: boolean) => { },
        getFilterOptionsList: (logged: boolean) => { },

        getStartupById: (id: string) => { },
        getStartupByIdGuest: (id: string) => { },
        IsLoadingGetStartupbyId: true,
        setIsLoadingGetStartupbyId: (isLoading: boolean) => { },
        setStartUpById: (startUpById: DTOStartupById) => { },
        startUpById: {},

        //MATCH
        isLoadingMatch: false,
        setIsLoadingMatch: (par: boolean) => { },
        matchList: [],
        setMatchList: (par: Match[]) => { },
        pagerMatchList: initialPager,
        setPagerMatchList: (pager: Pager) => { },
        reqMatchList: initialReqMatchList,
        setReqMatchList: (par: MatchListReq) => { },
        getMatchList: () => { },


        //MESSAGES
        matchSelected: undefined,
        setMatchSelected: (par: Match | undefined) => { },
        startupAcceptedMatch: undefined,
        setStartupAcceptedMatch: (par: StartupAcceptedMatchType | undefined) => { },
        isLoadingMessages: false,
        setIsLoadingMessages: (par: boolean) => { },
        messagesList: [],
        setMessagesList: (par: ChatMessage[]) => { },
        pagerMessagesList: initialPager,
        setPagerMessagesList: (pager: Pager) => { },
        reqMessagesList: initialReqMessagesList,
        setReqMessagesList: (par: MessagesListReq) => { },
        getMessagesList: () => { },

        changePWisOpen: false,
        setchangePWisOpen: (par: boolean) => { },

        tags: {},
        setTags: (opt: MultiValue<OptionTypes> | undefined) => { },
        sectors: {},
        setSectors: (opt: MultiValue<OptionTypes> | undefined) => { },
        cities: {},
        setCities: (opt: MultiValue<OptionTypes> | undefined) => { },
        constitutionStatus: {},
        setConstitutionStatus: (opt: MultiValue<OptionTypes> | undefined) => { },

        servicesList: [],
        setServiceList: (services: Service[]) => { },
        bannerList: [],
        setBannerList: (services: Service[]) => { },
        getBannerList: () => { },
        matchFeaturedService: (serviceId: string) => { },

    });

export const AppGeneralContextProvider = ({ children }: ContextProviderProps) => {
    const mobile = useMediaQuery(MediaMobile, true)

    const [baseUri, setBaseUri] = useState<string | undefined>()
    const [loginType, setLoginType] = useState<LoginType | undefined>()

    const [isForgotPassword, setIsForgotPassword] = useState<boolean>(false)
    const [isChooseNewPassword, setIsChooseNewPassword] = useState<boolean>(false)
    const [forgotPWNewEmail, setForgotPWNewEmail] = useState<string>("")

    const [user, setUser] = useState<User | undefined>()
    const [userInfo, setUserInfo] = useState<UserInfo>(initialuserInfo)
    const [startUp, setStartUp] = useState<StartUp>(initalStartUp)
    const [numberMatchRequest, setNumberMatchRequest] = useState<number>(0)
    const [chatIsOpen, setChatIsOpen] = useState<boolean>(false)
    const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false)
    const [blockScroll, allowScroll] = useScrollBlock()
    const [changePWisOpen, setchangePWisOpen] = useState<boolean>(false)

    const [resetEmailisOpen,setresetEmailisOPen] = useState<boolean>(false)
    const [generateVerifCodeisOpen,setGenerateCodeisOpen] = useState<boolean>(false)
    
    const [isLoadingCorporates, setIsLoadingCorporates] = useState(true)
    const [corporate, setCorporate] = useState<Corporate>(initialCorporate)
    const [corporatesList, setCorporatesList] = useState<Corporate[]>([])
    const [pagerCorporatesList, setPagerCorporatesList] = useState<Pager>(initialPager)
    const [reqCorporate, setReqCorporate] = useState<CompaniesListReq>(initialReqCorporate)

    const [isLoadingStartups, setIsLoadingStartups] = useState(true)
    const [startupsList, setStartupsList] = useState<StartUp[]>([])
    const [pagerStartupsList, setPagerStartupsList] = useState<Pager>(initialPager)
    const [reqStartup, setReqStartup] = useState<StartupsListReq>(initialReqStartup)

    const [isLoadingMatch, setIsLoadingMatch] = useState<boolean>(true)
    const [matchList, setMatchList] = useState<Match[]>([])
    const [pagerMatchList, setPagerMatchList] = useState<Pager>(initialPager)
    const [reqMatchList, setReqMatchList] = useState<MatchListReq>({ ...initialReqMatchList, pageSize: mobile ? PAGE_SIZE.matchListMobile : PAGE_SIZE.matchList })

    const [matchSelected, setMatchSelected] = useState<Match | undefined>(undefined)
    const [startupAcceptedMatch, setStartupAcceptedMatch] = useState<StartupAcceptedMatchType | undefined>()
    const [isLoadingMessages, setIsLoadingMessages] = useState<boolean>(true)
    const [messagesList, setMessagesList] = useState<ChatMessage[]>([])
    const [pagerMessagesList, setPagerMessagesList] = useState<Pager>(initialPager)
    const [reqMessagesList, setReqMessagesList] = useState<MessagesListReq>(initialReqMessagesList)

    const [servicesList, setServiceList] = useState<Service[]>([])
    const [bannerList, setBannerList] = useState<Service[]>([])

    const [startUpIdforMatch, setstartUpIdforMatch] = useState<string>("")

    const [modal, setModal] = useState<Modal>(initialStateModal)

    const setLoadingModal = () =>
        setModal({ isOpen: true, type: ModalType.loading, title: "Loading", message: "Loading data, please wait" })
    const setErrorModal = (error?: string) => {
        if (error === `${StatusCode.NOT_AUTHORIZED}`) return
        setModal({
            isOpen: true, type: ModalType.error,
            title: !error ? "Please Wait" :
                // error === `${StatusCode.NOT_AUTHORIZED}` ? "Please Login" :
                error === `${StatusCode.EMAIL_NOT_AVAIABLE}` ? "The email is already registered" :
                    "Please Wait",
            message: !error ? "Something went wrong" :
                // error === `${StatusCode.NOT_AUTHORIZED}` ? "You are currently disconnected. Please login or register in order to access the Innovation Match platform." :
                error === `${StatusCode.EMAIL_NOT_AVAIABLE}` ? "Please go back to the homepage to log in." :
                    error
        })
    };
 

    useEffect(()=>{console.log(resetEmailisOpen)}, [resetEmailisOpen])

    const setClosedModal = () => setModal(initialStateModal)

    const [loadingDepartmentOptions, setLoadingDepartmentOptions] = useState<boolean>(true)
    const [departmentOptions, setDepartmentOptions] = useState<OptionTypes[]>([])

    const [loadingLevelsOptions, setLoadingLevelsOptions] = useState<boolean>(true)
    const [levelsOptions, setLevelOptions] = useState<OptionTypes[]>([])

    const [loadingFilterOptions, setLoadingFilterOptions] = useState<boolean>(true)
    const [filter, setFilter] = useState<Filter>({})
    const [modalDatesIsOpen, setModalDatesIsOpen] = useState<boolean>(false);
    const [dateResponse, setDateResponse] = useState<DatesResponse>(initialStateDatesResponse);

    const [matchCallDates, setMatchCallDates] = useState<MatchDate[] | undefined>(undefined)

    const [IsLoadingGetStartupbyId, setIsLoadingGetStartupbyId] = useState<boolean>(true);
    const [startUpById, setStartUpById] = useState<DTOStartupById>({});
    const [modalChildren, setModalChildren] = useState<ModalChildrenPar>({});

    const [tags, setTags] = useState<MultiValue<OptionTypes>>()
    const [sectors, setSectors] = useState<MultiValue<OptionTypes>>()
    const [cities, setCities] = useState<MultiValue<OptionTypes>>()
    const [constitutionStatus, setConstitutionStatus] = useState<MultiValue<OptionTypes>>()

    //reload data 
    useEffect(() => {
        const uninterceptedAxiosInstance = axios.create();
        uninterceptedAxiosInstance.get(`${window.location.origin}/appSettings.json`)
            .then(({ data }: AxiosResponse<AppSettings>) => {
                setBaseUri(data.baseUrl);
            })
    }, [])

    useEffect(() => {
        if (modalDatesIsOpen || modal.isOpen) {
            blockScroll()
        } else {
            allowScroll()
        }
    }, [modalDatesIsOpen, modal.isOpen])

    const getUserData = useCallback(
        (whoLogsIn: number) => {

            const userLoaded = getUser().then((res) => {
                if (!res.isSuccess || !res.response) {
                    return false
                }
                const response = res.response

                const user = { ...response.user, role: response.role }
                setUser(user)
                setLoginType(whoLogsIn)

                if (whoLogsIn === LoginType.startup) {
                    setStartUp(response.role as StartUp)
                    let role = response.role as StartUp
                    setNumberMatchRequest(role.currentCounter.availableMonthMatches)
                }

                if (whoLogsIn === LoginType.corporate) {
                    setCorporate(response.role as Corporate)
                }
                return true

            })

            return userLoaded
        },
        [loginType]
    )

    const getDepartmentsOptionsList = () => {
        setLoadingDepartmentOptions(true)
        getDepartmentsList().then((res) => {
            setLoadingDepartmentOptions(false)

            if (!res.isSuccess || !res.response) {
                setErrorModal(res.error)
                return false
            }

            const response = res.response
            setDepartmentOptions(response.departments)
        })
    }

    const getLevelOptionsList = () => {
        setLoadingLevelsOptions(true)
        getLevelList().then((res) => {
            setLoadingLevelsOptions(false)

            if (!res.isSuccess || !res.response) {
                setErrorModal(res.error)
                return false
            }

            const response = res.response
            setLevelOptions(response.levels)
        })
    }

    const getFilterOptionsList = useCallback((logged: boolean) => {

        setLoadingFilterOptions(true)

        if (!logged) {

            setLoadingFilterOptions(false)
            return
        }

        getFilterList().then((res) => {
            setLoadingFilterOptions(false)

            if (!res.isSuccess || !res.response) {
                setErrorModal(res.error)
                setLoadingFilterOptions(false)
                return false
            }

            let response: Filter = {
                departments: res.response.departements,
                sectors: res.response?.sectors,
                tags: res.response?.tags,
                levels: res.response?.levels,
                constitutionStatus: res.response?.constitutionStatus
            }


            setFilter(response)

        })

    }, [loadingFilterOptions])

    const getCorporatesList = useCallback(
        () => {
            setIsLoadingCorporates(true)
            postCompaniesList(reqCorporate).then((res) => {

                setIsLoadingCorporates(false)

                if (!res.isSuccess || !res.response) {
                    setErrorModal(res.error)
                    return false
                }
                let currentCompaniesData: any[] = []

                if (reqCorporate.pageNum > 0) {
                    currentCompaniesData = corporatesList
                }
                const companiesList = currentCompaniesData.concat(res.response.data)
                setCorporatesList(companiesList)
                setPagerCorporatesList(res.response.pager)
            })
        },
        [corporatesList, reqCorporate],
    )

    const getStartupsList = useCallback((logged: boolean, filters?:StartupsListFiltersReq) => {
        setIsLoadingStartups(true)

        if (!logged) {
            return
        }

        const filteredReq = {
            ...reqStartup,
            ...(filters ?? {})
        }

        postStartupsList(filteredReq).then((res) => {

            setIsLoadingStartups(false)

            if (!res.isSuccess || !res.response) {
                setErrorModal(res.error)
                return false
            }

            let currentStartupsData: any[] = []

            if (reqStartup.pageNum > 0) {
                currentStartupsData = startupsList
            }

            const list = currentStartupsData.concat(res.response.data)

            setStartupsList(list)
            setPagerStartupsList(res.response.pager)


        })
    }, [reqStartup, startupsList, tags, sectors, constitutionStatus])

    // messageList size
    const [pageSize, setPageSize] = useState(6)
    const mobileD = useMediaQuery(MediaMobile)

    useEffect(() => {
        const height = window.innerHeight
        if (!user?.email) {
            return
        }

        if (mobileD) {
            setPageSize(3)
            getMatchList()
            return
        }

        if (height >= 450) {
            let pageSize: number = height / 150

            setPageSize(parseInt(pageSize.toFixed(0)))
        } else if (height >= 380 && height < 450) {
            setPageSize(2)
        } else {
            setPageSize(1)
        }

        getMatchList()

    }, [window.innerHeight, user?.email])

    const getMatchList = useCallback(() => {
        setIsLoadingMatch(true)
        const req = { ...reqMatchList, pageSize: pageSize }
        if (user?.email) {
            postMatchList(req).then((res) => {
                setIsLoadingMatch(false)

                if (!res.isSuccess || !res.response) {
                    setErrorModal(res.error)
                    return false
                }
                const response = res.response.data
                setPagerMatchList(res.response.pager)
                setMatchList(response)
            })
        }
    }, [user?.email, mobile, reqMatchList, reqMatchList?.searchText, reqMatchList?.orderBy, reqMatchList?.orderDirection, reqMatchList?.pageNum, reqMatchList?.pageSize, window.innerHeight])

    useEffect(() => {
        if (user?.email) {
            const updateData = setInterval(() => {
                getMatchList()
            }, 30000)
            return () => clearInterval(updateData)
        }
    }, [user?.email])

    const getMessagesList = useCallback(() => {
        setIsLoadingMessages(true)
        if (reqMessagesList.matchId) {
            postMessagesList(reqMessagesList).then((res) => {
                setIsLoadingMessages(false)

                if (!res.isSuccess || !res.response) {
                    setErrorModal(res.error)
                    return false
                }

                const response = res.response.data
                const messages: ChatMessage[] = response.map((x, i, messagesList) => {
                    let isOld = (i === (response.length - 1) ? false : true)
                    let showDate: boolean
                    if (i === 0) {
                        showDate = true
                    } else {
                        showDate = dayMonthYearString(messagesList[i - 1].dateAction) === dayMonthYearString(x.dateAction) ? false : true
                    }
                    return { ...x, acceptedMatch: false, isOldMessage: isOld, showDate: showDate }
                });

                setMessagesList(messages)
                //set accepted match
                response.map(x => {
                    if (x.status === MatchStatus.CompanySentAvailability || x.status === MatchStatus.CompanyStartedMatch) {
                        let accepted: StartupAcceptedMatchType = { matchId: x.matchId, acceptedMatch: false }
                        return setStartupAcceptedMatch(accepted)
                    } else {
                        return setStartupAcceptedMatch(undefined)
                    }
                })
            })
        }
    }, [reqMessagesList, reqMessagesList?.matchId, reqMessagesList?.orderBy, reqMessagesList?.orderDirection, reqMessagesList?.pageNum, reqMessagesList?.pageSize])

    useEffect(() => {
        if (!startUpIdforMatch) {
            return
        }
        const auth = authHelper.getAuth();
        
        if (auth?.jwtToken) {
            getStartupById(startUpIdforMatch)
            return
        }
        getStartupByIdGuest(startUpIdforMatch)
    }, [startUpIdforMatch])

    const getStartupById = (startupId: string) => {
        
        setIsLoadingGetStartupbyId(true)
        getStartUpByID(startupId).then((res) => {
            setIsLoadingGetStartupbyId(false)
            if (!res.isSuccess || !res.response) {
                setErrorModal(res.error)
                return
            }
            setStartUpById(res.response.data)
            setClosedModal()
        })
    }

    const getStartupByIdGuest = (startupId: string) => {
        

        setIsLoadingGetStartupbyId(true)
        callGetStartupByIdGuest(startupId).then((res) => {
            setIsLoadingGetStartupbyId(false)
            if (!res.isSuccess || !res.response) {
                setErrorModal(res.error)
                return
            }
            setStartUpById(res.response.data)
            setClosedModal()
        })
    }


    const resetMatchCallDates = () => {
        setMatchCallDates(undefined)
    }

    useEffect(() => {
        if (user?.id) {
            getDepartmentsOptionsList()
            getLevelOptionsList()
        }
    }, [user?.id])

    const getBannerList = () => {
        getServicesBanner().then((res) => {
            if (!res.isSuccess && !res.response) {
                setErrorModal(res.error)
                return
            }

            let resp = res.response?.data
            if (resp)
                setBannerList(resp)

        })
    }

    const matchFeaturedService = (serviceId: string) => {
        getMatchFeaturedServices(serviceId).then((res) => {
            if (!res.isSuccess || !res.response) {
                setErrorModal(res.error)
                return
            }

            getBannerList();
            return
        })


    }

    const generalCtx: AppGeneralContextType = {
        baseUri,
        loginType, setLoginType,
        isForgotPassword, setIsForgotPassword,
        isChooseNewPassword, setIsChooseNewPassword,
        forgotPWNewEmail, setForgotPWNewEmail,
        user, setUser,
        userInfo, setUserInfo,
        startUp, setStartUp,
        numberMatchRequest, setNumberMatchRequest,
        chatIsOpen, setChatIsOpen,
        menuIsOpen, setMenuIsOpen,
        pagerCorporatesList, setPagerCorporatesList,
        reqCorporate, setReqCorporate,
        corporate, setCorporate,
        corporatesList, setCorporatesList,
        isLoadingCorporates, setIsLoadingCorporates,
        getCorporatesList,
        pagerStartupsList, setPagerStartupsList,
        reqStartup, setReqStartup,
        startupsList, setStartupsList,
        isLoadingStartups, setIsLoadingStartups,
        getStartupsList,
        getUserData,
        modal, setModal,
        setLoadingModal, setErrorModal, setClosedModal,
        modalDatesIsOpen, setModalDatesIsOpen,
        dateResponse, setDateResponse,
        matchCallDates, setMatchCallDates,
        resetMatchCallDates,
        loadingDepartmentOptions, setLoadingDepartmentOptions,
        departmentOptions, setDepartmentOptions,
        getDepartmentsOptionsList,
        loadingLevelsOptions, setLoadingLevelsOptions,
        levelsOptions, setLevelOptions,
        getLevelOptionsList,
        filter, setFilter,
        loadingFilterOptions, setLoadingFilterOptions,
        getFilterOptionsList,
        matchSelected, setMatchSelected,
        startupAcceptedMatch, setStartupAcceptedMatch,
        isLoadingMessages, setIsLoadingMessages,
        messagesList, setMessagesList,
        pagerMessagesList, setPagerMessagesList,
        reqMessagesList, setReqMessagesList,
        getMessagesList,
        isLoadingMatch, setIsLoadingMatch,
        matchList, setMatchList,
        pagerMatchList, setPagerMatchList,
        reqMatchList, setReqMatchList,
        getMatchList,
        startUpIdforMatch, setstartUpIdforMatch,
        IsLoadingGetStartupbyId, setIsLoadingGetStartupbyId,
        startUpById, setStartUpById,
        getStartupById,
        getStartupByIdGuest,
        modalChildren, setModalChildren,
        changePWisOpen, setchangePWisOpen,
        resetEmailisOpen, setresetEmailisOPen,
        generateVerifCodeisOpen,setGenerateCodeisOpen,
        tags, setTags,
        sectors, setSectors,
        cities, setCities,
        constitutionStatus, setConstitutionStatus,
        servicesList, setServiceList,
        bannerList, setBannerList,
        getBannerList,
        matchFeaturedService

    }

    return (
        <AppGeneralContext.Provider value={generalCtx}>
            {children}
        </AppGeneralContext.Provider>
    )

}


